/**
 * ============================================================================
 * StickyWidget — View (UI only)
 * ============================================================================
 */
"use client";

import UnivoImage from "@/components/common/UnivoImage";
import { IMAGE_ASSETS } from "@/constants/images";
import styles from "../StickyWidget.module.scss";
import type { StickyWidgetViewModel } from "../model/stickyWidget.types";

export default function StickyWidgetView(vm: StickyWidgetViewModel) {
  const { isVisible, stickyWidget, close, onClickhandler } = vm;
  return (
    <div
      className={styles.root}
      data-sticky-widget
      style={{
        position: "fixed",
        zIndex: 9999,
        boxSizing: "border-box",
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",
        transition: "opacity 0.2s ease",
      }}
      aria-hidden={!isVisible}
    >
      <button className={styles.closeBtn} onClick={close} aria-label="Close">
        <svg
          width="22"
          height="22"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM11.44 11.44C11.128 11.752 10.624 11.752 10.312 11.44L8 9.128L5.688 11.44C5.376 11.752 4.872 11.752 4.56 11.44C4.248 11.128 4.248 10.624 4.56 10.312L6.872 8L4.56 5.688C4.248 5.376 4.248 4.872 4.56 4.56C4.872 4.248 5.376 4.248 5.688 4.56L8 6.872L10.312 4.56C10.624 4.248 11.128 4.248 11.44 4.56C11.752 4.872 11.752 5.376 11.44 5.688L9.128 8L11.44 10.312C11.744 10.616 11.744 11.128 11.44 11.44Z"
            fill="white"
          />
        </svg>
      </button>

      <div className={styles.body} onClick={onClickhandler}>
        <div className={styles.imgCol}>
          <UnivoImage
            src={
              stickyWidget?.BannerImage?.url ??
              IMAGE_ASSETS.stickyScholarshipFallback
            }
            alt="Scholarship"
            width={293}
            height={220}
            quality={85}
            sizes="(max-width: 48rem) 12.5rem, 18.3125rem"
            className={styles.img}
            style={{ width: "100%", height: "100%" }}
            priority
          />
        </div>
      </div>
    </div>
  );
}
